export default[
  {
    path: "/login",
    name: "login",
    meta:{
      title: '登录页'
    },
    component: () => import("../../views/login.vue")
  },
  {
    path: "/screen",
    name: "screen",
    meta:{
      title: '固废数据大屏',
      permission: ''
    },
    component: () => import("../../views/screen.vue")
  },
  {
    path: "/screen1",
    name: "screen1",
    meta:{
      title: '危废数据大屏',
      permission: ''
    },
    component: () => import("../../views/screen1.vue")
  }
]
